import { useCallback } from 'react';
import { toast } from 'react-toastify';
import useHttp from './useHttp';
import { useAuth } from '../context/authContext';

const useSpecialSyncImport = () => {
  const { sendRequest } = useHttp();
  const auth = useAuth();

  const analyze = useCallback(
    async csvString => {
      try {
        const data = await sendRequest(
          {
            url: '/api/v1/user/sync-import/analyze',
            method: 'POST',
            headers: auth.getAuthHeaders({ withAuth: true }),
            body: { csv: csvString },
          },
          'Zusätzliche Authentifizierung erforderlich: Sync-Import Analyse',
          null,
          { name: 'Sync-Import Analyse', info: 'CSV wird analysiert' },
          null,
          'Analyse erfolgreich'
        );
        return data;
      } catch (e) {
        toast.error('Fehler bei der Analyse der CSV');
        throw e;
      }
    },
    [sendRequest, auth]
  );

  const execute = useCallback(
    async payload => {
      try {
        const data = await sendRequest(
          {
            url: '/api/v1/user/sync-import/execute',
            method: 'POST',
            headers: auth.getAuthHeaders({ withAuth: true }),
            body: payload,
          },
          'Zusätzliche Authentifizierung erforderlich: Sync-Import Ausführung',
          null,
          { name: 'Sync-Import Ausführung', info: 'Ausgewählte Aktionen werden angewendet' },
          null,
          'Aktionen erfolgreich ausgeführt'
        );
        return data;
      } catch (e) {
        toast.error('Fehler bei der Ausführung der Änderungen');
        throw e;
      }
    },
    [sendRequest, auth]
  );

  return { analyze, execute };
};

export default useSpecialSyncImport;
